import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Vuetify from "vuetify";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { Field } from "@/modules/FormTemplate/models/Field";
import { Condition } from "@/modules/FormTemplate/models/Condition";
import ConditionalComponent from "../CoditionalComponent/ConditionalComponent.vue";
import ModifVJsfInput from "@/shared/components/ModifVJsfInput/ModifVJsfInput.vue";
import { VJSF_OPTIONS } from "@/shared/constants/FormConstants";

Vue.use(Vuetify);

@Component({
  name: "FieldComponent",
  components: {
    EmptyState,
    ConditionalComponent,
    ModifVJsfInput
  }
})
export default class FieldComponent extends Vue {
  @Prop() private fields!: Field[];
  @Prop() private formConditions!: Condition[];

  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  cardClass = STYLE_CLASSES.CARD;
  FIELD_EMPTY_STATE_HEADER = FORM_TEMP_CONSTANTS.FIELD_LABEL.EMPTY_STATE_HEADER;
  FIELD_EMPTY_STATE_PARAGRAPH =
    FORM_TEMP_CONSTANTS.FIELD_LABEL.EMPTY_STATE_PARAGRAPH;

  model = {};
  EDIT_FIELD =
    FORM_TEMP_CONSTANTS.FIELD_COMPONENT_TOOLTIPS.BTN_TOOLTIPS.EDIT_FIELD;
  DELETE_FIELD =
    FORM_TEMP_CONSTANTS.FIELD_COMPONENT_TOOLTIPS.BTN_TOOLTIPS.DELETE_FIELD;
  ADD_CONDITION =
    FORM_TEMP_CONSTANTS.FIELD_COMPONENT_TOOLTIPS.BTN_TOOLTIPS.ADD_CONDITION;
  VJSF_OPTIONS = VJSF_OPTIONS;

  editField(index: number) {
    this.fields[index].model = {};
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.FIELD.EDIT, index);
  }

  deleteField(index: number) {
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.FIELD.DELETE, index);
  }

  saveNewFieldOrder() {
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.FIELD.SAVE_NEW_ORDER);
  }

  getSchema(index: number) {
    const schema = {
      type: "object",
      properties: {
        field: {}
      },
      "x-cols": {
        md: this.fields[index].width
      }
    };

    schema.properties.field = this.fields[index].schema;
    return schema;
  }

  openConditionDialog(index: number) {
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.CONDITION.ADD_NEW, index);
  }

  show(key: string) {
    const val = this.formConditions.find(
      fc => fc.condition.parentField === key
    );
    if (val !== undefined) {
      return true;
    } else {
      return false;
    }
  }

  modifyCondition(action: string, index: number) {
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.CONDITION.MODIFY, action, index);
  }

  modifyConditionalField(action: string, data: any) {
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.CONDITION.FIELD.MODIFY, action, data);
  }
}
